import { useEffect, useState } from "react";
import { Ticket, Copy } from "lucide-react";
import { toast } from "sonner";
import { api, inr } from "../lib/api";

export default function ProductCoupons({ price }) {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/coupons").then((r) => setList(r.data)).catch(() => {}); }, []);
  if (!list.length) return null;
  const copy = (c) => { navigator.clipboard?.writeText(c).catch(() => {}); toast.success(`Coupon ${c} copied – apply it in your cart`); };
  return (
    <div className="rounded-2xl border border-dashed border-[#ffb703]/40 bg-[#ffb703]/5 p-4 space-y-2" data-testid="product-coupons">
      <p className="text-sm font-semibold flex items-center gap-2"><Ticket size={15} className="text-[#ffb703]" />Coupons for you</p>
      {list.slice(0, 4).map((c) => {
        const save = c.type === "percent" ? Math.min(Math.round((price * c.value) / 100), c.max_discount || Infinity) : c.value;
        const ok = price >= (c.min_order || 0);
        return (
          <div key={c.code} className="flex flex-wrap items-center gap-2 text-xs" data-testid={`product-coupon-${c.code}`}>
            <button type="button" onClick={() => copy(c.code)} data-testid={`product-coupon-copy-${c.code}`} className="flex items-center gap-1 font-mono font-bold px-2 py-1 rounded border border-[#ffb703]/50 text-[#ffb703] hover:bg-[#ffb703]/10"><Copy size={11} />{c.code}</button>
            <span className="text-slate-300 flex-1 min-w-0">{c.description || (c.type === "percent" ? `${c.value}% off` : `${inr(c.value)} off`)}{c.min_order ? ` · on orders above ${inr(c.min_order)}` : ""}</span>
            {ok && save > 0 && <span className="text-emerald-400 font-semibold">Save {inr(save)}</span>}
          </div>
        );
      })}
    </div>
  );
}
